import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, vModelRadio as _vModelRadio, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f4677e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-5" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12 mb-7" }
const _hoisted_6 = { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed p-6" }
const _hoisted_7 = { class: "svg-icon svg-icon-2tx svg-icon-primary me-4" }
const _hoisted_8 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_9 = { class: "text-gray-900 fw-bold" }
const _hoisted_10 = { class: "fw-semibold" }
const _hoisted_11 = { class: "fs-6 text-gray-400" }
const _hoisted_12 = {
  key: 0,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_13 = { class: "form-label fw-bold required" }
const _hoisted_14 = {
  key: 1,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_15 = { class: "form-label fw-bold required" }
const _hoisted_16 = {
  key: 2,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_17 = { class: "form-label fw-bold required" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-2-4 flex-column" }
const _hoisted_20 = { class: "text-gray-400 mb-1" }
const _hoisted_21 = { class: "col-md-2-4 flex-column" }
const _hoisted_22 = { class: "text-gray-400 mb-1" }
const _hoisted_23 = { class: "col-md-2-4 flex-column" }
const _hoisted_24 = { class: "text-gray-400 mb-1" }
const _hoisted_25 = { class: "col-md-2-4 flex-column" }
const _hoisted_26 = { class: "text-gray-400 mb-1" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-2-4 flex-column" }, null, -1))
const _hoisted_28 = { class: "card" }
const _hoisted_29 = { class: "card-body p-9" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = {
  key: 0,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_32 = { class: "form-label fw-bold required" }
const _hoisted_33 = {
  key: 1,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_34 = { class: "form-label fw-bold required" }
const _hoisted_35 = { class: "col-md-12" }
const _hoisted_36 = { class: "d-flex justify-content-between" }
const _hoisted_37 = { class: "fw-bolder" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = {
  key: 0,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_40 = { class: "fw-bold text-muted" }
const _hoisted_41 = {
  key: 1,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_42 = { class: "form-label fw-bold" }
const _hoisted_43 = {
  key: 2,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_44 = { class: "fw-bold text-muted" }
const _hoisted_45 = {
  key: 3,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_46 = { class: "form-label fw-bold required" }
const _hoisted_47 = {
  key: 4,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_48 = { class: "fw-bold text-muted" }
const _hoisted_49 = {
  key: 5,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_50 = { class: "form-label fw-bold required" }
const _hoisted_51 = {
  key: 6,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_52 = { class: "fw-bold text-muted" }
const _hoisted_53 = {
  key: 7,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_54 = { class: "form-label fw-bold" }
const _hoisted_55 = {
  key: 8,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_56 = { class: "fw-bold text-muted" }
const _hoisted_57 = {
  key: 9,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_58 = { class: "form-label fw-bold required" }
const _hoisted_59 = {
  key: 10,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_60 = { class: "fw-bold text-muted" }
const _hoisted_61 = {
  key: 11,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_62 = { class: "form-label fw-bold required" }
const _hoisted_63 = {
  key: 12,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_64 = { class: "fw-bold text-muted" }
const _hoisted_65 = {
  key: 13,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_66 = { class: "form-label fw-bold required" }
const _hoisted_67 = {
  key: 14,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_68 = { class: "fw-bold text-muted" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = {
  key: 15,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_71 = { class: "form-label fw-bold required" }
const _hoisted_72 = {
  key: 16,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_73 = { class: "fw-bold text-muted" }
const _hoisted_74 = {
  key: 17,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_75 = { class: "form-label fw-bold" }
const _hoisted_76 = {
  key: 18,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_77 = { class: "fw-bold text-muted" }
const _hoisted_78 = {
  key: 19,
  class: "col-md-3 form-group"
}
const _hoisted_79 = { class: "form-label fw-bold required" }
const _hoisted_80 = {
  key: 2,
  class: "col-md-12 my-7"
}
const _hoisted_81 = { class: "d-flex" }
const _hoisted_82 = { class: "d-flex align-items-center" }
const _hoisted_83 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_84 = ["disabled"]
const _hoisted_85 = { class: "ms-2" }
const _hoisted_86 = {
  key: 3,
  class: "mb-7"
}
const _hoisted_87 = {
  key: 4,
  class: "col-md-12"
}
const _hoisted_88 = { class: "fw-bolder" }
const _hoisted_89 = { class: "row" }
const _hoisted_90 = {
  key: 0,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_91 = { class: "fw-bold text-muted" }
const _hoisted_92 = {
  key: 1,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_93 = { class: "form-label fw-bold" }
const _hoisted_94 = {
  key: 2,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_95 = { class: "fw-bold text-muted" }
const _hoisted_96 = {
  key: 3,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_97 = { class: "form-label fw-bold required" }
const _hoisted_98 = {
  key: 4,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_99 = { class: "fw-bold text-muted" }
const _hoisted_100 = {
  key: 5,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_101 = { class: "form-label fw-bold required" }
const _hoisted_102 = {
  key: 6,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_103 = { class: "fw-bold text-muted" }
const _hoisted_104 = {
  key: 7,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_105 = { class: "form-label fw-bold" }
const _hoisted_106 = {
  key: 8,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_107 = { class: "fw-bold text-muted" }
const _hoisted_108 = {
  key: 9,
  class: "col-md-6 form-group mb-7"
}
const _hoisted_109 = { class: "form-label fw-bold required" }
const _hoisted_110 = {
  key: 10,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_111 = { class: "fw-bold text-muted" }
const _hoisted_112 = {
  key: 11,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_113 = { class: "form-label fw-bold required" }
const _hoisted_114 = {
  key: 12,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_115 = { class: "fw-bold text-muted" }
const _hoisted_116 = {
  key: 13,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_117 = { class: "form-label fw-bold required" }
const _hoisted_118 = {
  key: 14,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_119 = { class: "fw-bold text-muted" }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = {
  key: 15,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_122 = { class: "form-label fw-bold required" }
const _hoisted_123 = {
  key: 16,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_124 = { class: "fw-bold text-muted" }
const _hoisted_125 = {
  key: 17,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_126 = { class: "form-label fw-bold" }
const _hoisted_127 = {
  key: 18,
  class: "col-md-3 form-group mb-7"
}
const _hoisted_128 = { class: "fw-bold text-muted" }
const _hoisted_129 = {
  key: 19,
  class: "col-md-3 form-group"
}
const _hoisted_130 = { class: "form-label fw-bold required" }
const _hoisted_131 = { class: "card card-flush" }
const _hoisted_132 = { class: "card-header pt-5" }
const _hoisted_133 = { class: "card-title flex-column justify-content-center" }
const _hoisted_134 = { key: 0 }
const _hoisted_135 = { class: "card-toolbar flex-wrap gap-3" }
const _hoisted_136 = {
  key: 0,
  class: "align-self-start nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fw-bold"
}
const _hoisted_137 = {
  key: 1,
  type: "button",
  class: "btn btn-light-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_sales_order_add_product_item"
}
const _hoisted_138 = { class: "svg-icon svg-icon-2" }
const _hoisted_139 = { class: "card-body pt-0" }
const _hoisted_140 = { class: "table-responsive" }
const _hoisted_141 = { class: "text-start text-gray-400 fw-bold text-uppercase gs-0" }
const _hoisted_142 = { class: "text-start" }
const _hoisted_143 = { class: "text-start" }
const _hoisted_144 = {
  key: 0,
  class: "text-start"
}
const _hoisted_145 = { class: "text-end" }
const _hoisted_146 = { class: "text-end" }
const _hoisted_147 = { class: "text-end" }
const _hoisted_148 = { class: "text-end" }
const _hoisted_149 = { class: "text-end" }
const _hoisted_150 = { class: "text-end" }
const _hoisted_151 = {
  key: 1,
  class: "text-end"
}
const _hoisted_152 = { class: "fw-bold text-gray-800" }
const _hoisted_153 = { key: 0 }
const _hoisted_154 = { class: "text-start" }
const _hoisted_155 = { class: "d-flex flex-column" }
const _hoisted_156 = { class: "d-flex align-items-center gap-2" }
const _hoisted_157 = {
  key: 0,
  src: "media/svg/custom/embargoes.svg"
}
const _hoisted_158 = {
  key: 1,
  class: "badge badge-danger text-uppercase"
}
const _hoisted_159 = { class: "mw-150px fs-7 text-line-clamp-1 text-gray-400" }
const _hoisted_160 = { class: "text-end text-nowrap" }
const _hoisted_161 = { class: "d-flex justify-content-end el-input el-input-group--append el-input--suffix" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-input-group__append d-flex w-auto flex-center" }, " € ", -1))
const _hoisted_163 = { class: "text-end" }
const _hoisted_164 = { class: "text-end" }
const _hoisted_165 = { class: "text-end text-nowrap" }
const _hoisted_166 = { class: "text-end text-nowrap" }
const _hoisted_167 = { class: "text-end text-nowrap" }
const _hoisted_168 = {
  key: 0,
  class: "fs-7"
}
const _hoisted_169 = {
  key: 0,
  class: "text-end text-nowrap"
}
const _hoisted_170 = ["title", "onClick"]
const _hoisted_171 = { class: "svg-icon svg-icon-3" }
const _hoisted_172 = ["title", "disabled", "onClick"]
const _hoisted_173 = { class: "svg-icon svg-icon-3" }
const _hoisted_174 = { class: "text-end text-nowrap" }
const _hoisted_175 = { class: "d-flex justify-content-end el-input el-input-group--append el-input--suffix" }
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-input-group__append d-flex w-auto flex-center" }, " € ", -1))
const _hoisted_177 = { class: "text-end" }
const _hoisted_178 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_179 = { class: "d-flex el-input el-input-group" }
const _hoisted_180 = { class: "position-relative" }
const _hoisted_181 = { class: "d-flex justify-content-end el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_182 = { class: "el-input-group__append d-flex w-auto flex-center px-0" }
const _hoisted_183 = { class: "text-end text-nowrap" }
const _hoisted_184 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_185 = { class: "text-end text-nowrap" }
const _hoisted_186 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_187 = { class: "d-flex el-input el-input-group--append el-input--suffix" }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-input-group__append d-flex w-auto flex-center" }, " € ", -1))
const _hoisted_189 = { class: "text-end text-nowrap" }
const _hoisted_190 = {
  key: 0,
  class: "fs-7"
}
const _hoisted_191 = { class: "text-end text-nowrap" }
const _hoisted_192 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-light me-3"
}
const _hoisted_193 = { class: "svg-icon svg-icon-3" }
const _hoisted_194 = ["onClick"]
const _hoisted_195 = { class: "svg-icon svg-icon-3" }
const _hoisted_196 = ["onClick"]
const _hoisted_197 = { class: "svg-icon svg-icon-3" }
const _hoisted_198 = ["colspan"]
const _hoisted_199 = ["colspan"]
const _hoisted_200 = { class: "d-flex flex-column gap-6" }
const _hoisted_201 = { class: "fs-4 fw-bold" }
const _hoisted_202 = { class: "fs-4 fw-bold" }
const _hoisted_203 = { class: "text-end text-nowrap align-baseline" }
const _hoisted_204 = { class: "d-flex flex-column gap-6" }
const _hoisted_205 = { class: "fs-4 fw-bold" }
const _hoisted_206 = {
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_draft_orders_update_shipping_fee",
  class: "svg-icon svg-icon-3 ms-2 me-0 cursor-pointer"
}
const _hoisted_207 = { class: "fs-4 fw-bold" }
const _hoisted_208 = {
  key: 0,
  class: "fs-6 text-gray-400"
}
const _hoisted_209 = { class: "min-w-240px fs-7 fw-bold" }
const _hoisted_210 = { class: "row mb-1" }
const _hoisted_211 = { class: "col-md-6" }
const _hoisted_212 = { class: "col-md-6" }
const _hoisted_213 = { class: "row" }
const _hoisted_214 = { class: "col-md-6" }
const _hoisted_215 = { class: "col-md-6" }
const _hoisted_216 = { class: "svg-icon svg-icon-3" }
const _hoisted_217 = {
  key: 0,
  class: "card"
}
const _hoisted_218 = { class: "card-body p-9" }
const _hoisted_219 = { class: "row" }
const _hoisted_220 = { class: "col-md-12" }
const _hoisted_221 = { class: "row" }
const _hoisted_222 = { class: "col-md-12" }
const _hoisted_223 = { class: "fw-bolder required" }
const _hoisted_224 = { class: "row" }
const _hoisted_225 = { class: "col-md-12 form-group mb-7" }
const _hoisted_226 = { class: "row" }
const _hoisted_227 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_228 = ["value"]
const _hoisted_229 = { class: "ms-2" }
const _hoisted_230 = {
  key: 1,
  class: "card"
}
const _hoisted_231 = { class: "card-header" }
const _hoisted_232 = { class: "card-title m-0" }
const _hoisted_233 = { class: "fw-boldest m-0" }
const _hoisted_234 = { class: "card-body p-9" }
const _hoisted_235 = { class: "row" }
const _hoisted_236 = { class: "col-md-6 form-group mb-7" }
const _hoisted_237 = { class: "form-label fw-bold required" }
const _hoisted_238 = { class: "col-md-6 form-group mb-7" }
const _hoisted_239 = { class: "form-label fw-bold required" }
const _hoisted_240 = { class: "d-flex el-input el-input-group el-input-group--append el-input--suffix" }
const _hoisted_241 = { class: "el-input-group__append d-flex w-auto flex-center px-0" }
const _hoisted_242 = { class: "d-flex flex-column gap-5" }
const _hoisted_243 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_244 = { class: "d-flex flex-column gap-5" }
const _hoisted_245 = ["disabled"]
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_247 = { class: "svg-icon svg-icon-3" }
const _hoisted_248 = ["disabled"]
const _hoisted_249 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_250 = { class: "svg-icon svg-icon-3" }
const _hoisted_251 = ["disabled"]
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_253 = { class: "svg-icon svg-icon-3" }
const _hoisted_254 = ["disabled"]
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_256 = { class: "svg-icon svg-icon-3" }
const _hoisted_257 = { class: "d-flex flex-column gap-5" }
const _hoisted_258 = { class: "d-flex flex-wrap justify-content-between gap-2" }
const _hoisted_259 = { class: "me-2" }
const _hoisted_260 = { class: "svg-icon svg-icon-2 svg-icon-gray-600" }
const _hoisted_261 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_262 = ["disabled"]
const _hoisted_263 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_264 = { class: "svg-icon svg-icon-3" }
const _hoisted_265 = ["disabled"]
const _hoisted_266 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_267 = { class: "svg-icon svg-icon-3" }
const _hoisted_268 = ["disabled"]
const _hoisted_269 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_270 = { class: "svg-icon svg-icon-3" }
const _hoisted_271 = ["disabled"]
const _hoisted_272 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_273 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_common_product = _resolveComponent("common-product")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_empty_data = _resolveComponent("empty-data")!
  const _component_window_resize = _resolveComponent("window-resize")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_add_product_item_modal = _resolveComponent("add-product-item-modal")!
  const _component_add_sku_modal = _resolveComponent("add-sku-modal")!
  const _component_range_size_change = _resolveComponent("range-size-change")!
  const _component_update_shipping_fee = _resolveComponent("update-shipping-fee")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      rules: _ctx.rules,
      model: _ctx.formData,
      ref: "formRef"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen017.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h4", _hoisted_9, _toDisplayString(_ctx.getOwnerLabel(_ctx.getDefaultOwnerId)), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("salesOrderOverview.operatingEntity")), 1)
                      ])
                    ])
                  ])
                ]),
                (!_ctx.isDoubleSale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("salesOrder.type")), 1),
                      _createVNode(_component_el_form_item, { prop: "config_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.config_name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.config_name) = $event)),
                            disabled: "",
                            type: "text",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDoubleSale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t("salesOrder.customer")), 1),
                      _createVNode(_component_el_form_item, { prop: "customer_id" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            modelValue: _ctx.formData.customer_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.customer_id) = $event)),
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect'),
                            loading: _ctx.options.companyLoading,
                            disabled: _ctx.formData.order_number !== '',
                            onChange: _ctx.customerChange
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.company, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder", "loading", "disabled", "onChange"])
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.t("salesOrder.customer")), 1),
                      _createVNode(_component_el_form_item, { prop: "user_account_name" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.formData.user_account_name,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.user_account_name) = $event)),
                            disabled: "",
                            type: "text",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.t("salesOrderOverview.group")) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.formData.profile.group_name ? _ctx.formData.profile.group_name : "--"), 1)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t("salesOrderOverview.email")) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.formData.profile.email ? _ctx.formData.profile.email : "--"), 1)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.t("salesOrderOverview.mobileNumber")) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.formData.profile.mobile_number
                  ? _ctx.formData.profile.mobile_number
                  : "--"), 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.t("salesOrderOverview.tecrmGuideId")) + ": ", 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.formData.profile.tecrm_guide_id
                  ? _ctx.formData.profile.tecrm_guide_id
                  : "--"), 1)
                ]),
                _hoisted_27
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                (_ctx.isDoubleSale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.t("order.merchant")), 1),
                      _createVNode(_component_el_form_item, { prop: "merchant" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            modelValue: _ctx.formData.merchant,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.merchant) = $event)),
                            filterable: "",
                            clearable: "",
                            "remote-show-suffix": "",
                            remote: "",
                            "remote-method": _ctx.searchMerchantSourceItems,
                            loading: _ctx.options.merchantLoading,
                            placeholder: _ctx.t('common.plsSelect'),
                            disabled: _ctx.isDoubleSale,
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getSalesChannelsData($event, true)))
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.merchant, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "remote-method", "loading", "placeholder", "disabled"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDoubleSale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("order.channel")), 1),
                      _createVNode(_component_el_form_item, { prop: "channel" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            modelValue: _ctx.formData.channel,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.channel) = $event)),
                            clearable: "",
                            loading: _ctx.options.channelLoading,
                            disabled: !_ctx.formData.merchant || _ctx.isDoubleSale,
                            placeholder: _ctx.t('common.plsSelect')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.channel, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "loading", "disabled", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("h3", _hoisted_37, _toDisplayString(_ctx.t("salesOrder.shippingAddress")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    (_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                          _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.t("salesOrder.shippingAddress")) + ":", 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.getShippingAddressDetail ? _ctx.getShippingAddressDetail : "--"), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.t("salesOrder.shippingAddress")), 1),
                          _createVNode(_component_el_form_item, { prop: "shipping_address_id" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.shippingAddress,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.shippingAddress) = $event)),
                                filterable: "",
                                clearable: "",
                                placeholder: _ctx.t('common.plsSelect'),
                                loading: _ctx.options.shippingAddressLoading,
                                disabled: _ctx.formData.customer_id === '',
                                onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addressChange($event, 'shipping')))
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.shippingAddress, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder", "loading", "disabled"])
                            ]),
                            _: 1
                          })
                        ])),
                    (_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                          _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.t("salesOrder.recipientFirstName")) + ":", 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.firstname
                        ? _ctx.formData.shipping_address.firstname
                        : "--"), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.t("salesOrder.recipientFirstName")), 1),
                          _createVNode(_component_el_form_item, { prop: "shipping_address.firstname" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.shipping_address.firstname,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.shipping_address.firstname) = $event)),
                                modelModifiers: { trim: true },
                                type: "text",
                                clearable: "",
                                disabled: _ctx.isDoubleSale,
                                placeholder: _ctx.t('common.plsEnter')
                              }, null, 8, ["modelValue", "disabled", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])),
                    (_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.t("salesOrder.recipientLastName")) + ":", 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.lastname
                        ? _ctx.formData.shipping_address.lastname
                        : "--"), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createElementVNode("label", _hoisted_50, _toDisplayString(_ctx.t("salesOrder.recipientLastName")), 1),
                          _createVNode(_component_el_form_item, { prop: "shipping_address.lastname" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.shipping_address.lastname,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.shipping_address.lastname) = $event)),
                                modelModifiers: { trim: true },
                                type: "text",
                                clearable: "",
                                disabled: _ctx.isDoubleSale,
                                placeholder: _ctx.t('common.plsEnter')
                              }, null, 8, ["modelValue", "disabled", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])),
                    (_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.t("salesOrder.recipientCompany")) + ":", 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.company
                        ? _ctx.formData.shipping_address.company
                        : "--"), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.t("salesOrder.recipientCompany")), 1),
                          _createVNode(_component_el_form_item, { prop: "shipping_address.company" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.shipping_address.company,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.shipping_address.company) = $event)),
                                modelModifiers: { trim: true },
                                type: "text",
                                clearable: "",
                                disabled: _ctx.isDoubleSale,
                                placeholder: _ctx.t('common.plsEnter')
                              }, null, 8, ["modelValue", "disabled", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])),
                    (_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                          _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.t("salesOrder.recipientStreetAddress")) + ":", 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.street
                        ? _ctx.formData.shipping_address.street
                        : "--"), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.t("salesOrder.recipientStreetAddress")), 1),
                          _createVNode(_component_el_form_item, { prop: "shipping_address.street" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.shipping_address.street,
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.shipping_address.street) = $event)),
                                modelModifiers: { trim: true },
                                type: "text",
                                clearable: "",
                                disabled: _ctx.isDoubleSale,
                                placeholder: _ctx.t('common.plsEnter')
                              }, null, 8, ["modelValue", "disabled", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])),
                    (_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                          _createElementVNode("label", _hoisted_60, _toDisplayString(_ctx.t("salesOrder.recipientCity")) + ":", 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.city
                        ? _ctx.formData.shipping_address.city
                        : "--"), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_61, [
                          _createElementVNode("label", _hoisted_62, _toDisplayString(_ctx.t("salesOrder.recipientCity")), 1),
                          _createVNode(_component_el_form_item, { prop: "shipping_address.city" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.shipping_address.city,
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.shipping_address.city) = $event)),
                                modelModifiers: { trim: true },
                                type: "text",
                                clearable: "",
                                disabled: _ctx.isDoubleSale,
                                placeholder: _ctx.t('common.plsEnter')
                              }, null, 8, ["modelValue", "disabled", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])),
                    (_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.t("salesOrder.recipientProvince")) + ":", 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.region
                        ? _ctx.formData.shipping_address.region
                        : "--"), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                          _createElementVNode("label", _hoisted_66, _toDisplayString(_ctx.t("salesOrder.recipientProvince")), 1),
                          _createVNode(_component_el_form_item, { prop: "shipping_address.region" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.shipping_address.region,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.shipping_address.region) = $event)),
                                modelModifiers: { trim: true },
                                type: "text",
                                clearable: "",
                                disabled: _ctx.isDoubleSale,
                                placeholder: _ctx.t('common.plsEnter')
                              }, null, 8, ["modelValue", "disabled", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])),
                    (_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                          _createElementVNode("label", _hoisted_68, _toDisplayString(_ctx.t("salesOrder.recipientCountry")) + ":", 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.country, (item) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: item.value
                            }, [
                              (
                        item.value === _ctx.formData.shipping_address.country_iso_2
                      )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_69, _toDisplayString(item.label), 1))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                          _createElementVNode("label", _hoisted_71, _toDisplayString(_ctx.t("salesOrder.recipientCountry")), 1),
                          _createVNode(_component_el_form_item, { prop: "shipping_address.country_iso_2" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                class: "w-100",
                                modelValue: _ctx.formData.shipping_address.country_iso_2,
                                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.shipping_address.country_iso_2) = $event)),
                                clearable: "",
                                filterable: "",
                                disabled: _ctx.isDoubleSale,
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.country, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.value,
                                      label: item.label,
                                      value: item.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "disabled", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])),
                    (_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                          _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.t("salesOrder.recipientPostalCode")) + ":", 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.zip_code
                        ? _ctx.formData.shipping_address.zip_code
                        : "--"), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.t("salesOrder.recipientPostalCode")), 1),
                          _createVNode(_component_el_form_item, { prop: "shipping_address.zip_code" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.shipping_address.zip_code,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.shipping_address.zip_code) = $event)),
                                modelModifiers: { trim: true },
                                type: "text",
                                clearable: "",
                                disabled: _ctx.isDoubleSale,
                                placeholder: _ctx.t('common.plsEnter')
                              }, null, 8, ["modelValue", "disabled", "placeholder"])
                            ]),
                            _: 1
                          })
                        ])),
                    (_ctx.isDoubleSale)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                          _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.t("salesOrder.recipientMobileNo")) + ":", 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.formData.shipping_address.telephone
                        ? _ctx.formData.shipping_address.telephone
                        : "--"), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_78, [
                          _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.t("salesOrder.recipientMobileNo")), 1),
                          _createVNode(_component_el_form_item, { prop: "shipping_address.telephone" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.formData.shipping_address.telephone,
                                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.shipping_address.telephone) = $event)),
                                modelModifiers: { trim: true },
                                type: "text",
                                clearable: "",
                                disabled: _ctx.isDoubleSale,
                                placeholder: _ctx.t('common.plsEnter')
                              }, null, 8, ["modelValue", "disabled", "placeholder"])
                            ]),
                            _: 1
                          })
                        ]))
                  ])
                ]),
                (!_ctx.isDoubleSale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("label", {
                          class: _normalizeClass(["d-flex align-items-center cursor-pointer", {
                    'cursor-nodrop': _ctx.formData.customer_id === '',
                  }])
                        }, [
                          _createElementVNode("div", _hoisted_82, [
                            _createElementVNode("span", _hoisted_83, [
                              _withDirectives(_createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                name: "same_billing_address",
                                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.isSameBillingAddress) = $event)),
                                value: true,
                                disabled: _ctx.formData.customer_id === '' || _ctx.isDoubleSale,
                                onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.sameAddressChange && _ctx.sameAddressChange(...args)))
                              }, null, 40, _hoisted_84), [
                                [_vModelCheckbox, _ctx.formData.isSameBillingAddress]
                              ])
                            ]),
                            _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.t("salesOrderOverview.sameAsBillingAddress")), 1)
                          ])
                        ], 2)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_86)),
                (!_ctx.formData.isSameBillingAddress || _ctx.isDoubleSale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_87, [
                      _createElementVNode("h3", _hoisted_88, _toDisplayString(_ctx.t("salesOrder.billingAddress")), 1),
                      _createElementVNode("div", _hoisted_89, [
                        (_ctx.isDoubleSale)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
                              _createElementVNode("label", _hoisted_91, _toDisplayString(_ctx.t("salesOrder.billingAddress")) + ":", 1),
                              _createElementVNode("div", null, _toDisplayString(_ctx.getBillingAddressDetail ? _ctx.getBillingAddressDetail : "--"), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_92, [
                              _createElementVNode("label", _hoisted_93, _toDisplayString(_ctx.t("salesOrder.billingAddress")), 1),
                              _createVNode(_component_el_form_item, { prop: "billing_address_id" }, {
                                default: _withCtx(() => [
                                  (_ctx.isDoubleSale)
                                    ? (_openBlock(), _createBlock(_component_el_input, {
                                        key: 0,
                                        modelValue: _ctx.getBillingAddressDetail,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.getBillingAddressDetail) = $event)),
                                        type: "text",
                                        clearable: "",
                                        disabled: true,
                                        placeholder: _ctx.t('common.plsEnter')
                                      }, null, 8, ["modelValue", "placeholder"]))
                                    : (_openBlock(), _createBlock(_component_el_select, {
                                        key: 1,
                                        class: "w-100",
                                        modelValue: _ctx.formData.billingAddress,
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.billingAddress) = $event)),
                                        filterable: "",
                                        clearable: "",
                                        placeholder: _ctx.t('common.plsSelect'),
                                        loading: _ctx.options.billingAddressLoading,
                                        disabled: _ctx.formData.customer_id === '' || _ctx.isDoubleSale,
                                        onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addressChange($event, 'billing')))
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.shippingAddress, (item) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: item.value,
                                              label: item.label,
                                              value: item
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "placeholder", "loading", "disabled"]))
                                ]),
                                _: 1
                              })
                            ])),
                        (_ctx.isDoubleSale)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                              _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.t("salesOrder.billingFirstName")) + ":", 1),
                              _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.firstname
                        ? _ctx.formData.billing_address.firstname
                        : "--"), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_96, [
                              _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.t("salesOrder.billingFirstName")), 1),
                              _createVNode(_component_el_form_item, { prop: "billing_address.firstname" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.billing_address.firstname,
                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.billing_address.firstname) = $event)),
                                    modelModifiers: { trim: true },
                                    type: "text",
                                    clearable: "",
                                    disabled: _ctx.isDoubleSale,
                                    placeholder: _ctx.t('common.plsEnter')
                                  }, null, 8, ["modelValue", "disabled", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])),
                        (_ctx.isDoubleSale)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                              _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.t("salesOrder.billingLastName")) + ":", 1),
                              _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.lastname
                        ? _ctx.formData.billing_address.lastname
                        : "--"), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_100, [
                              _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.t("salesOrder.billingLastName")), 1),
                              _createVNode(_component_el_form_item, { prop: "billing_address.lastname" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.billing_address.lastname,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.billing_address.lastname) = $event)),
                                    modelModifiers: { trim: true },
                                    type: "text",
                                    clearable: "",
                                    disabled: _ctx.isDoubleSale,
                                    placeholder: _ctx.t('common.plsEnter')
                                  }, null, 8, ["modelValue", "disabled", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])),
                        (_ctx.isDoubleSale)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                              _createElementVNode("label", _hoisted_103, _toDisplayString(_ctx.t("salesOrder.billingCompany")) + ":", 1),
                              _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.company
                        ? _ctx.formData.billing_address.company
                        : "--"), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_104, [
                              _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.t("salesOrder.billingCompany")), 1),
                              _createVNode(_component_el_form_item, { prop: "billing_address.company" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.billing_address.company,
                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.billing_address.company) = $event)),
                                    modelModifiers: { trim: true },
                                    type: "text",
                                    clearable: "",
                                    disabled: _ctx.isDoubleSale,
                                    placeholder: _ctx.t('common.plsEnter')
                                  }, null, 8, ["modelValue", "disabled", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])),
                        (_ctx.isDoubleSale)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                              _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.t("salesOrder.billingStreetAddress")) + ":", 1),
                              _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.street
                        ? _ctx.formData.billing_address.street
                        : "--"), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_108, [
                              _createElementVNode("label", _hoisted_109, _toDisplayString(_ctx.t("salesOrder.billingStreetAddress")), 1),
                              _createVNode(_component_el_form_item, { prop: "billing_address.street" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.billing_address.street,
                                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.billing_address.street) = $event)),
                                    modelModifiers: { trim: true },
                                    type: "text",
                                    clearable: "",
                                    disabled: _ctx.isDoubleSale,
                                    placeholder: _ctx.t('common.plsEnter')
                                  }, null, 8, ["modelValue", "disabled", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])),
                        (_ctx.isDoubleSale)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                              _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.t("salesOrder.billingCity")) + ":", 1),
                              _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.city
                        ? _ctx.formData.billing_address.city
                        : "--"), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_112, [
                              _createElementVNode("label", _hoisted_113, _toDisplayString(_ctx.t("salesOrder.billingCity")), 1),
                              _createVNode(_component_el_form_item, { prop: "billing_address.city" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.billing_address.city,
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.billing_address.city) = $event)),
                                    modelModifiers: { trim: true },
                                    type: "text",
                                    clearable: "",
                                    disabled: _ctx.isDoubleSale,
                                    placeholder: _ctx.t('common.plsEnter')
                                  }, null, 8, ["modelValue", "disabled", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])),
                        (_ctx.isDoubleSale)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                              _createElementVNode("label", _hoisted_115, _toDisplayString(_ctx.t("salesOrder.billingStateProvince")) + ":", 1),
                              _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.region
                        ? _ctx.formData.billing_address.region
                        : "--"), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_116, [
                              _createElementVNode("label", _hoisted_117, _toDisplayString(_ctx.t("salesOrder.billingStateProvince")), 1),
                              _createVNode(_component_el_form_item, { prop: "billing_address.region" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.billing_address.region,
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.billing_address.region) = $event)),
                                    modelModifiers: { trim: true },
                                    type: "text",
                                    clearable: "",
                                    disabled: _ctx.isDoubleSale,
                                    placeholder: _ctx.t('common.plsEnter')
                                  }, null, 8, ["modelValue", "disabled", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])),
                        (_ctx.isDoubleSale)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                              _createElementVNode("label", _hoisted_119, _toDisplayString(_ctx.t("salesOrder.billingCountry")) + ":", 1),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.country, (item) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: item.value
                                }, [
                                  (
                        item.value === _ctx.formData.billing_address.country_iso_2
                      )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_120, _toDisplayString(item.label), 1))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_121, [
                              _createElementVNode("label", _hoisted_122, _toDisplayString(_ctx.t("salesOrder.billingCountry")), 1),
                              _createVNode(_component_el_form_item, { prop: "billing_address.country_iso_2" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    class: "w-100",
                                    modelValue: _ctx.formData.billing_address.country_iso_2,
                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.billing_address.country_iso_2) = $event)),
                                    clearable: "",
                                    filterable: "",
                                    disabled: _ctx.isDoubleSale,
                                    placeholder: _ctx.t('common.plsSelect')
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.country, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.value,
                                          label: item.label,
                                          value: item.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "disabled", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])),
                        (_ctx.isDoubleSale)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                              _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.t("salesOrder.billingPostalCode")) + ":", 1),
                              _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.zip_code
                        ? _ctx.formData.billing_address.zip_code
                        : "--"), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_125, [
                              _createElementVNode("label", _hoisted_126, _toDisplayString(_ctx.t("salesOrder.billingPostalCode")), 1),
                              _createVNode(_component_el_form_item, { prop: "billing_address.zip_code" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.billing_address.zip_code,
                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.billing_address.zip_code) = $event)),
                                    modelModifiers: { trim: true },
                                    type: "text",
                                    clearable: "",
                                    disabled: _ctx.isDoubleSale,
                                    placeholder: _ctx.t('common.plsEnter')
                                  }, null, 8, ["modelValue", "disabled", "placeholder"])
                                ]),
                                _: 1
                              })
                            ])),
                        (_ctx.isDoubleSale)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                              _createElementVNode("label", _hoisted_128, _toDisplayString(_ctx.t("salesOrder.billingContactMobileNo")) + ":", 1),
                              _createElementVNode("div", null, _toDisplayString(_ctx.formData.billing_address.telephone
                        ? _ctx.formData.billing_address.telephone
                        : "--"), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_129, [
                              _createElementVNode("label", _hoisted_130, _toDisplayString(_ctx.t("salesOrder.billingContactMobileNumber")), 1),
                              _createVNode(_component_el_form_item, { prop: "billing_address.telephone" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.formData.billing_address.telephone,
                                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.billing_address.telephone) = $event)),
                                    modelModifiers: { trim: true },
                                    type: "text",
                                    clearable: "",
                                    disabled: _ctx.isDoubleSale,
                                    placeholder: _ctx.t('common.plsEnter')
                                  }, null, 8, ["modelValue", "disabled", "placeholder"])
                                ]),
                                _: 1
                              })
                            ]))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_131, [
            _createElementVNode("div", _hoisted_132, [
              _createElementVNode("div", _hoisted_133, [
                _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrderOverview.orderItems")), 1),
                (_ctx.isDoubleSale)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_134, [
                      _createVNode(_component_el_radio_group, {
                        class: "text-sm",
                        modelValue: _ctx.options.doubleSaleProductTabFilterValue,
                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.options.doubleSaleProductTabFilterValue) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: 0 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("common.all")), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: 1 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("draftOrder.abnormalCases")), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_135, [
                (_ctx.isDoubleSale)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_136, [
                      _createElementVNode("li", {
                        class: "nav-item",
                        onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.changeTab(0)))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["nav-link cursor-pointer ms-0 pt-0", {
                    'active text-active-primary':
                      _ctx.options.doubleSaleProductTabIndex === 0,
                  }])
                        }, _toDisplayString(_ctx.t("draftOrder.publishedItems")), 3)
                      ]),
                      _createElementVNode("li", {
                        class: "nav-item",
                        onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.changeTab(1)))
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["nav-link cursor-pointer ms-0 pt-0", {
                    'active text-active-primary':
                      _ctx.options.doubleSaleProductTabIndex === 1,
                  }])
                        }, _toDisplayString(_ctx.t("draftOrder.deletedItems")), 3)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("button", _hoisted_137, [
                      _createElementVNode("span", _hoisted_138, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.t("salesOrderOverview.addProduct")), 1)
                    ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_139, [
              _createElementVNode("div", _hoisted_140, [
                _createElementVNode("table", {
                  class: _normalizeClass(["table table-row-bordered gy-5 fs-6 mb-0", {
                'align-top': _ctx.isDoubleSale,
                'align-middle': !_ctx.isDoubleSale,
              }])
                }, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", _hoisted_141, [
                      _createElementVNode("th", _hoisted_142, _toDisplayString(_ctx.t("order.product")), 1),
                      _createElementVNode("th", _hoisted_143, _toDisplayString(_ctx.t("order.sku")), 1),
                      (_ctx.isDoubleSale)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_144, _toDisplayString(_ctx.$t("draftOrder.hsCode")), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("th", _hoisted_145, _toDisplayString(_ctx.t("order.originalPrice")), 1),
                      _createElementVNode("th", _hoisted_146, _toDisplayString(_ctx.t("orderRequest.qtyConf")), 1),
                      _createElementVNode("th", _hoisted_147, _toDisplayString(_ctx.isDoubleSale ? _ctx.t("order.margin") : _ctx.t("order.discount")), 1),
                      _createElementVNode("th", _hoisted_148, _toDisplayString(_ctx.t("order.tax")), 1),
                      _createElementVNode("th", _hoisted_149, _toDisplayString(_ctx.t("orderRequest.netPrice")), 1),
                      _createElementVNode("th", _hoisted_150, _toDisplayString(_ctx.t("orderRequest.total")), 1),
                      (
                      !_ctx.isDoubleSale || (_ctx.isDoubleSale && !_ctx.isDisabledDoubleEdit)
                    )
                        ? (_openBlock(), _createElementBlock("th", _hoisted_151, _toDisplayString(_ctx.t("common.action")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_152, [
                    (_ctx.isDoubleSale)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.formData.draft_items, (item, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (item.product_id !== 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  (
                          (_ctx.options.doubleSaleProductTabIndex === 0 &&
                            !item.is_deleted) ||
                          (_ctx.options.doubleSaleProductTabIndex === 1 &&
                            item.is_deleted)
                        )
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        (
                            _ctx.options.doubleSaleProductTabFilterValue === 0 ||
                            (_ctx.options.doubleSaleProductTabFilterValue === 1 &&
                              item.in_blacklist)
                          )
                                          ? (_openBlock(), _createElementBlock("tr", _hoisted_153, [
                                              (_openBlock(), _createBlock(_component_common_product, {
                                                gallery: _ctx.getSkuListItemImages(item),
                                                brand_id: item.brand,
                                                brand_article_no: item.brand_article_no,
                                                merchant_article_no: item.merchant_article_no,
                                                product_identifier_id: '0',
                                                source_link: '',
                                                name: item.name,
                                                name_en: item.name,
                                                color: item.color_label,
                                                size: item.size_label,
                                                rangeSize: item.range_size,
                                                eanShow: true,
                                                ean: item.ean_code,
                                                countryShow: true,
                                                country: item.country_of_origin,
                                                key: index
                                              }, null, 8, ["gallery", "brand_id", "brand_article_no", "merchant_article_no", "name", "name_en", "color", "size", "rangeSize", "ean", "country"])),
                                              _createElementVNode("td", _hoisted_154, [
                                                _createVNode(_component_el_popover, {
                                                  placement: "top",
                                                  width: "auto",
                                                  trigger: "hover",
                                                  disabled: !item.material
                                                }, {
                                                  reference: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_155, [
                                                      _createElementVNode("div", _hoisted_156, [
                                                        _createElementVNode("span", {
                                                          class: _normalizeClass({
                                          'text-danger': item.in_blacklist,
                                        })
                                                        }, _toDisplayString(item.hs_code ? item.hs_code : "--"), 3),
                                                        (item.in_blacklist)
                                                          ? (_openBlock(), _createElementBlock("img", _hoisted_157))
                                                          : _createCommentVNode("", true),
                                                        (item.is_new)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_158, "New"))
                                                          : _createCommentVNode("", true)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_159, _toDisplayString(item.material ? item.material : "--"), 1)
                                                    ])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", null, _toDisplayString(item.material), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["disabled"])
                                              ]),
                                              _createElementVNode("td", _hoisted_160, [
                                                _createVNode(_component_el_form_item, {
                                                  class: "m-0",
                                                  prop: 'draft_items.' + index + '.base_price'
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_161, [
                                                      _createVNode(_component_el_input_number, {
                                                        class: "w-90px size-sm text-end",
                                                        modelValue: item.base_price,
                                                        "onUpdate:modelValue": ($event: any) => ((item.base_price) = $event),
                                                        precision: 2,
                                                        step: 0.01,
                                                        min: 0.01,
                                                        controls: false,
                                                        onInput: ($event: any) => (
                                      _ctx.priceChange(
                                        $event,
                                        item,
                                        'base_gross_price'
                                      )
                                    )
                                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "min", "onInput"]),
                                                      _hoisted_162
                                                    ])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["prop"])
                                              ]),
                                              _createElementVNode("td", _hoisted_163, _toDisplayString(item.qty), 1),
                                              _createElementVNode("td", _hoisted_164, _toDisplayString(_ctx.getDoubleMargin(item.discount) + "%"), 1),
                                              _createElementVNode("td", _hoisted_165, _toDisplayString(item.tax_rate + "%"), 1),
                                              _createElementVNode("td", _hoisted_166, _toDisplayString(_ctx.$currency.currency(
                                  item.net_price,
                                  2,
                                  ",",
                                  ".",
                                  "€ "
                                )), 1),
                                              _createElementVNode("td", _hoisted_167, [
                                                _createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                                    _ctx.getItemAmountTotal(
                                      item.qty,
                                      _ctx.getGrossPrice(item),
                                      0,
                                      2,
                                      _ctx.getTax(item.tax_rate),
                                      false
                                    ),
                                    2,
                                    ",",
                                    ".",
                                    "€ "
                                  )), 1),
                                                (_ctx.formData.order_currency_code === 'CNY')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_168, _toDisplayString(_ctx.$currency.currency(
                                    _ctx.getItemAmountTotal(
                                      item.qty,
                                      _ctx.getCNYGrossPrice(item),
                                      0,
                                      2,
                                      _ctx.getTax(item.tax_rate),
                                      false
                                    ),
                                    2,
                                    ".",
                                    "",
                                    "￥ "
                                  )), 1))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              (!_ctx.isDisabledDoubleEdit)
                                                ? (_openBlock(), _createElementBlock("td", _hoisted_169, [
                                                    _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                                      default: _withCtx(() => [
                                                        (item.is_deleted)
                                                          ? (_openBlock(), _createElementBlock("button", {
                                                              key: 0,
                                                              type: "button",
                                                              class: "btn btn-sm btn-icon btn-light",
                                                              title: _ctx.$t('common.restore'),
                                                              onClick: ($event: any) => (_ctx.removeDoubleItem(item))
                                                            }, [
                                                              _createElementVNode("span", _hoisted_171, [
                                                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr059.svg" })
                                                              ])
                                                            ], 8, _hoisted_170))
                                                          : (_openBlock(), _createElementBlock("button", {
                                                              key: 1,
                                                              type: "button",
                                                              class: "btn btn-sm btn-icon btn-light-danger",
                                                              title: _ctx.$t('common.delete'),
                                                              disabled: 
                                    _ctx.getDoubleProductNotDeletedItems.length === 1
                                  ,
                                                              onClick: ($event: any) => (_ctx.removeDoubleItem(item))
                                                            }, [
                                                              _createElementVNode("span", _hoisted_173, [
                                                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                                                              ])
                                                            ], 8, _hoisted_172))
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ], 64))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.formData.relation_item_draft, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: index }, [
                            (_openBlock(), _createBlock(_component_common_product, {
                              gallery: _ctx.getSkuListItemImages(item),
                              brand_id: item.brand,
                              brand_article_no: item.brand_article_no,
                              merchant_article_no: item.merchant_article_no,
                              product_identifier_id: '0',
                              source_link: '',
                              name: item.name,
                              name_en: item.name,
                              color: item.color_label,
                              size: item.size_label,
                              rangeSize: item.range_size,
                              key: index
                            }, null, 8, ["gallery", "brand_id", "brand_article_no", "merchant_article_no", "name", "name_en", "color", "size", "rangeSize"])),
                            _createElementVNode("td", _hoisted_174, [
                              _createVNode(_component_el_form_item, {
                                class: "m-0",
                                prop: 'relation_item_draft.' + index + '.base_price'
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_175, [
                                    _createVNode(_component_el_input_number, {
                                      class: "w-90px size-sm text-end",
                                      modelValue: item.base_price,
                                      "onUpdate:modelValue": ($event: any) => ((item.base_price) = $event),
                                      precision: 2,
                                      step: 0.01,
                                      min: 0.01,
                                      controls: false,
                                      onInput: ($event: any) => (_ctx.priceChange($event, item, 'base_price'))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "min", "onInput"]),
                                    _hoisted_176
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["prop"])
                            ]),
                            _createElementVNode("td", _hoisted_177, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_178, [
                                  _createVNode(_component_el_form_item, {
                                    class: "m-0",
                                    prop: 'relation_item_draft.' + index + '.qty'
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_179, [
                                        _createVNode(_component_el_input_number, {
                                          class: "w-90px size-sm text-end",
                                          modelValue: item.qty,
                                          "onUpdate:modelValue": ($event: any) => ((item.qty) = $event),
                                          precision: 0,
                                          step: 1,
                                          min: 1,
                                          controls: false
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["prop"])
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_180, [
                              _createVNode(_component_el_form_item, {
                                class: "position-relative m-0",
                                prop: 'relation_item_draft.' + index + '.discount'
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_181, [
                                    _createVNode(_component_el_input_number, {
                                      class: "w-75px size-sm text-end",
                                      modelValue: item.discount,
                                      "onUpdate:modelValue": ($event: any) => ((item.discount) = $event),
                                      precision: 2,
                                      step: 0.01,
                                      min: 0,
                                      controls: false,
                                      onInput: ($event: any) => (_ctx.priceChange($event, item, 'discount'))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "onInput"]),
                                    _createElementVNode("div", _hoisted_182, [
                                      _createVNode(_component_el_select, {
                                        class: "w-50px size-sm",
                                        modelValue: item.discount_type,
                                        "onUpdate:modelValue": ($event: any) => ((item.discount_type) = $event),
                                        placeholder: _ctx.t('common.plsSelect'),
                                        onChange: ($event: any) => (_ctx.priceChange($event, item, 'discount'))
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.discount, (row) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: row.value,
                                              label: row.label,
                                              value: row.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange"])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["prop"])
                            ]),
                            _createElementVNode("td", _hoisted_183, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_184, [
                                  _createVNode(_component_el_form_item, {
                                    class: "m-0",
                                    rules: _ctx.rules['relation_item_draft.tax_rate'],
                                    prop: 
                                'relation_item_draft.' + index + '.tax_rate'
                              
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        class: "w-100px size-sm",
                                        modelValue: item.tax_rate,
                                        "onUpdate:modelValue": ($event: any) => ((item.tax_rate) = $event),
                                        placeholder: _ctx.t('common.plsSelect')
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.tax_rates, (row, key) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: key,
                                              label: row.label,
                                              value: row.value
                                            }, null, 8, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"])
                                    ]),
                                    _: 2
                                  }, 1032, ["rules", "prop"])
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_185, [
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_186, [
                                  _createVNode(_component_el_form_item, {
                                    class: "m-0",
                                    prop: 
                                'relation_item_draft.' + index + '.net_price'
                              
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_187, [
                                        _createVNode(_component_el_input_number, {
                                          class: "w-90px size-sm text-end",
                                          modelValue: item.net_price,
                                          "onUpdate:modelValue": ($event: any) => ((item.net_price) = $event),
                                          precision: 2,
                                          step: 0.01,
                                          min: 0,
                                          controls: false,
                                          onInput: ($event: any) => (_ctx.priceChange($event, item, 'price'))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "step", "onInput"]),
                                        _hoisted_188
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["prop"])
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_189, [
                              _createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                              _ctx.getItemAmountTotal(
                                item.qty,
                                _ctx.getGrossPrice(item),
                                0,
                                2,
                                _ctx.getTax(item.tax_rate),
                                false
                              ),
                              2,
                              ",",
                              ".",
                              "€ "
                            )), 1),
                              (_ctx.formData.order_currency_code === 'CNY')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_190, _toDisplayString(_ctx.$currency.currency(
                              _ctx.getItemAmountTotal(
                                item.qty,
                                _ctx.getCNYGrossPrice(item),
                                0,
                                2,
                                _ctx.getTax(item.tax_rate),
                                false
                              ),
                              2,
                              ".",
                              "",
                              "￥ "
                            )), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_191, [
                              (item.remark)
                                ? (_openBlock(), _createBlock(_component_el_popover, {
                                    key: 0,
                                    placement: "top",
                                    width: "auto",
                                    trigger: "hover"
                                  }, {
                                    reference: _withCtx(() => [
                                      _createElementVNode("button", _hoisted_192, [
                                        _createElementVNode("span", _hoisted_193, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/communication/com007.svg" })
                                        ])
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.remark) + " ", 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                                default: _withCtx(() => [
                                  (
                              item.range_size || item.size_label == 'default'
                            )
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "btn btn-sm btn-icon btn-light me-3",
                                        "data-bs-toggle": "modal",
                                        "data-bs-target": "#modal_range_size_change",
                                        onClick: ($event: any) => (_ctx.rangeSizeModal(index))
                                      }, [
                                        _createElementVNode("span", _hoisted_195, [
                                          _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                        ])
                                      ], 8, _hoisted_194))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-sm btn-icon btn-light-danger",
                                    onClick: ($event: any) => (_ctx.removeItem(index))
                                  }, [
                                    _createElementVNode("span", _hoisted_197, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen027.svg" })
                                    ])
                                  ], 8, _hoisted_196)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]))
                        }), 128)),
                    _withDirectives(_createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        colspan: _ctx.isDoubleSale && !_ctx.isDisabledDoubleEdit ? 10 : 9
                      }, [
                        _createVNode(_component_empty_data)
                      ], 8, _hoisted_198)
                    ], 512), [
                      [_vShow, _ctx.isProductEmpty]
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        colspan: _ctx.isDoubleSale && !_ctx.isDisabledDoubleEdit ? 9 : 8,
                        class: "text-end align-baseline"
                      }, [
                        _createElementVNode("div", _hoisted_200, [
                          _createElementVNode("div", _hoisted_201, _toDisplayString(_ctx.t("orderRequest.shippingChargeInclTax")) + ": ", 1),
                          _createElementVNode("div", _hoisted_202, _toDisplayString(_ctx.t("orderRequest.total")) + ": ", 1)
                        ])
                      ], 8, _hoisted_199),
                      _createElementVNode("td", _hoisted_203, [
                        _createElementVNode("div", _hoisted_204, [
                          _createElementVNode("div", _hoisted_205, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$currency.currency(
                            _ctx.formData.base_shipping_amount,
                            2,
                            ",",
                            ".",
                            "€ "
                          )), 1),
                            _createElementVNode("span", _hoisted_206, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_207, [
                            _createElementVNode("div", null, _toDisplayString(_ctx.$currency.currency(
                              _ctx.getOrderItemsTotal,
                              2,
                              ",",
                              ".",
                              "€ "
                            )), 1),
                            (_ctx.formData.order_currency_code === 'CNY')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_208, [
                                  _createVNode(_component_el_popover, {
                                    placement: "top",
                                    width: "auto",
                                    trigger: "hover"
                                  }, {
                                    reference: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_216, [
                                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen045.svg" })
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_209, [
                                        _createElementVNode("div", _hoisted_210, [
                                          _createElementVNode("div", _hoisted_211, _toDisplayString(_ctx.t("salesOrderOverview.exchangeRate")) + ": ", 1),
                                          _createElementVNode("div", _hoisted_212, " € 1 ≈ ¥ " + _toDisplayString(_ctx.formData.order_rate), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_213, [
                                          _createElementVNode("div", _hoisted_214, _toDisplayString(_ctx.t("salesOrderOverview.payAmount")) + ": ", 1),
                                          _createElementVNode("div", _hoisted_215, _toDisplayString(_ctx.$currency.currency(
                                      _ctx.getCNYOrderItemsTotal,
                                      2,
                                      ".",
                                      "",
                                      "￥ "
                                    )), 1)
                                        ])
                                      ])
                                    ]),
                                    _: 1
                                  }),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$currency.currency(
                              _ctx.getCNYOrderItemsTotal,
                              2,
                              ".",
                              "",
                              "￥ "
                            )), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ], 2)
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ]),
          (0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_217, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_218, [
                  _createElementVNode("div", _hoisted_219, [
                    _createElementVNode("div", _hoisted_220, [
                      _createElementVNode("div", _hoisted_221, [
                        _createElementVNode("div", _hoisted_222, [
                          _createElementVNode("h3", _hoisted_223, _toDisplayString(_ctx.t("salesOrder.paymentMethod")), 1),
                          _createElementVNode("div", _hoisted_224, [
                            _createElementVNode("div", _hoisted_225, [
                              _createVNode(_component_el_form_item, { prop: "payment_method" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_226, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.payment_method, (item, index) => {
                                      return (_openBlock(), _createElementBlock("label", {
                                        class: "col-md-2-4 d-flex align-items-center cursor-pointer",
                                        key: index
                                      }, [
                                        _createElementVNode("span", _hoisted_227, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "form-check-input",
                                            type: "radio",
                                            name: "payment_method",
                                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData.payment_method) = $event)),
                                            value: item.value
                                          }, null, 8, _hoisted_228), [
                                            [_vModelRadio, _ctx.formData.payment_method]
                                          ])
                                        ]),
                                        _createElementVNode("span", _hoisted_229, _toDisplayString(item.label), 1)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.loading]
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.formData.config_id == '1' || _ctx.formData.config_id == '12')
            ? (_openBlock(), _createElementBlock("div", _hoisted_230, [
                _createElementVNode("div", _hoisted_231, [
                  _createElementVNode("div", _hoisted_232, [
                    _createElementVNode("h3", _hoisted_233, _toDisplayString(_ctx.t("salesOrder.typeDeposit")), 1)
                  ])
                ]),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_234, [
                  _createElementVNode("div", _hoisted_235, [
                    _createElementVNode("div", _hoisted_236, [
                      _createElementVNode("label", _hoisted_237, _toDisplayString(_ctx.t("salesOrderOverview.depositPaymentStatus")), 1),
                      _createVNode(_component_el_form_item, { prop: "deposit_payment_status" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            class: "w-100",
                            modelValue: _ctx.formData.deposit_payment_status,
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.formData.deposit_payment_status) = $event)),
                            filterable: "",
                            clearable: "",
                            placeholder: _ctx.t('common.plsSelect')
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.deposit_payment_status, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_238, [
                      _createElementVNode("label", _hoisted_239, _toDisplayString(_ctx.t("salesOrderOverview.depositPaidAmount")), 1),
                      _createVNode(_component_el_form_item, { prop: "deposit_amount" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_240, [
                            _createVNode(_component_el_input_number, {
                              class: "w-100 text-start",
                              modelValue: _ctx.formData.deposit_amount,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formData.deposit_amount) = $event)),
                              precision: 2,
                              step: 0.01,
                              min: 0,
                              controls: false
                            }, null, 8, ["modelValue", "step"]),
                            _createElementVNode("div", _hoisted_241, [
                              _createVNode(_component_el_select, {
                                class: "w-75px size-sm",
                                modelValue: _ctx.formData.deposit_currency,
                                "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formData.deposit_currency) = $event)),
                                placeholder: _ctx.t('common.plsSelect')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.currency, (row) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: row.value,
                                      label: row.label,
                                      value: row.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ])), [
                  [_directive_loading, _ctx.loading]
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_window_resize, null, {
            sm: _withCtx(() => [
              _createElementVNode("div", _hoisted_242, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn bg-secondary text-gray-600 w-100",
                  onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                }, [
                  _createElementVNode("span", _hoisted_243, [
                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.t("common.back")), 1)
                ]),
                _createElementVNode("div", _hoisted_244, [
                  _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                    default: _withCtx(() => [
                      (
                    !_ctx.isDoubleSale || (_ctx.isDoubleSale && !_ctx.isDisabledDoubleEdit)
                  )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-primary w-100",
                            disabled: _ctx.loading || _ctx.isDisabledSubmit,
                            onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                          }, [
                            _withDirectives(_createElementVNode("span", null, [
                              _hoisted_246,
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                            ], 512), [
                              [_vShow, _ctx.loading]
                            ]),
                            _withDirectives(_createElementVNode("span", null, [
                              _createElementVNode("span", _hoisted_247, [
                                _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/submit.svg" })
                              ]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.saveChanges")), 1)
                            ], 512), [
                              [_vShow, !_ctx.loading]
                            ])
                          ], 8, _hoisted_245))
                        : _createCommentVNode("", true),
                      (_ctx.isDoubleSale && !_ctx.isDisabledDoubleEdit)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-primary w-100",
                            disabled: 
                    _ctx.loading ||
                    _ctx.isChangeData ||
                    _ctx.formData.can_generate_order === 0 ||
                    _ctx.formData.order_number !== ''
                  ,
                            onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.createDraftOrderGenerateOrder && _ctx.createDraftOrderGenerateOrder(...args)))
                          }, [
                            _withDirectives(_createElementVNode("span", null, [
                              _hoisted_249,
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                            ], 512), [
                              [_vShow, _ctx.loading]
                            ]),
                            _withDirectives(_createElementVNode("span", null, [
                              _createElementVNode("span", _hoisted_250, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen043.svg" })
                              ]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("salesOrderOverview.generateOrder")), 1)
                            ], 512), [
                              [_vShow, !_ctx.loading]
                            ])
                          ], 8, _hoisted_248))
                        : (!_ctx.isDoubleSale)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              class: "btn btn-primary w-100",
                              disabled: 
                    _ctx.loading ||
                    _ctx.isChangeData ||
                    _ctx.isDisabledSubmit ||
                    _ctx.isDisabledCreate
                  ,
                              onClick: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.createDraftOrderGenerateOrder && _ctx.createDraftOrderGenerateOrder(...args)))
                            }, [
                              _withDirectives(_createElementVNode("span", null, [
                                _hoisted_252,
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                              ], 512), [
                                [_vShow, _ctx.loading]
                              ]),
                              _withDirectives(_createElementVNode("span", null, [
                                _createElementVNode("span", _hoisted_253, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen043.svg" })
                                ]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("salesOrderOverview.generateOrder")), 1)
                              ], 512), [
                                [_vShow, !_ctx.loading]
                              ])
                            ], 8, _hoisted_251))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (!_ctx.isDoubleSale)
                    ? (_openBlock(), _createBlock(_component_permission_common, {
                        key: 0,
                        role: { auth: ['delete'] }
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createElementVNode("button", {
                            type: "button",
                            class: "btn btn-light-danger w-100",
                            disabled: _ctx.loading,
                            onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.deleteDraftOrder && _ctx.deleteDraftOrder(...args)))
                          }, [
                            _withDirectives(_createElementVNode("span", null, [
                              _hoisted_255,
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                            ], 512), [
                              [_vShow, _ctx.loading]
                            ]),
                            _withDirectives(_createElementVNode("span", null, [
                              _createElementVNode("span", _hoisted_256, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                              ]),
                              _createElementVNode("span", null, _toDisplayString(_ctx.$t("salesOrder.delete")), 1)
                            ], 512), [
                              [_vShow, !_ctx.loading]
                            ])
                          ], 8, _hoisted_254), [
                            [_vShow, _ctx.isCanDelete]
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            lg: _withCtx(() => [
              _createElementVNode("div", _hoisted_257, [
                _createElementVNode("div", _hoisted_258, [
                  _createElementVNode("div", _hoisted_259, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn bg-secondary text-gray-600",
                      onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                    }, [
                      _createElementVNode("span", _hoisted_260, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr063.svg" })
                      ]),
                      _createElementVNode("span", null, _toDisplayString(_ctx.t("common.back")), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_261, [
                    (!_ctx.isDoubleSale)
                      ? (_openBlock(), _createBlock(_component_permission_common, {
                          key: 0,
                          role: { auth: ['delete'] }
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("button", {
                              type: "button",
                              class: "btn btn-light-danger",
                              disabled: _ctx.loading,
                              onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.deleteDraftOrder && _ctx.deleteDraftOrder(...args)))
                            }, [
                              _withDirectives(_createElementVNode("span", null, [
                                _hoisted_263,
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                              ], 512), [
                                [_vShow, _ctx.loading]
                              ]),
                              _withDirectives(_createElementVNode("span", null, [
                                _createElementVNode("span", _hoisted_264, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                                ]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("salesOrder.delete")), 1)
                              ], 512), [
                                [_vShow, !_ctx.loading]
                              ])
                            ], 8, _hoisted_262), [
                              [_vShow, _ctx.isCanDelete]
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                      default: _withCtx(() => [
                        (
                      !_ctx.isDoubleSale || (_ctx.isDoubleSale && !_ctx.isDisabledDoubleEdit)
                    )
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-primary",
                              disabled: _ctx.loading || _ctx.isDisabledSubmit,
                              onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
                            }, [
                              _withDirectives(_createElementVNode("span", null, [
                                _hoisted_266,
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                              ], 512), [
                                [_vShow, _ctx.loading]
                              ]),
                              _withDirectives(_createElementVNode("span", null, [
                                _createElementVNode("span", _hoisted_267, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/submit.svg" })
                                ]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.saveChanges")), 1)
                              ], 512), [
                                [_vShow, !_ctx.loading]
                              ])
                            ], 8, _hoisted_265))
                          : _createCommentVNode("", true),
                        (_ctx.isDoubleSale && !_ctx.isDisabledDoubleEdit)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "btn btn-primary",
                              disabled: 
                      _ctx.loading ||
                      _ctx.isChangeData ||
                      _ctx.formData.can_generate_order === 0
                    ,
                              onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.createDraftOrderGenerateOrder && _ctx.createDraftOrderGenerateOrder(...args)))
                            }, [
                              _withDirectives(_createElementVNode("span", null, [
                                _hoisted_269,
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                              ], 512), [
                                [_vShow, _ctx.loading]
                              ]),
                              _withDirectives(_createElementVNode("span", null, [
                                _createElementVNode("span", _hoisted_270, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen043.svg" })
                                ]),
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t("salesOrderOverview.generateOrder")), 1)
                              ], 512), [
                                [_vShow, !_ctx.loading]
                              ])
                            ], 8, _hoisted_268))
                          : (!_ctx.isDoubleSale)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                type: "button",
                                class: "btn btn-primary",
                                disabled: 
                      _ctx.loading ||
                      _ctx.isChangeData ||
                      _ctx.isDisabledSubmit ||
                      _ctx.isDisabledCreate
                    ,
                                onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.createDraftOrderGenerateOrder && _ctx.createDraftOrderGenerateOrder(...args)))
                              }, [
                                _withDirectives(_createElementVNode("span", null, [
                                  _hoisted_272,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                                ], 512), [
                                  [_vShow, _ctx.loading]
                                ]),
                                _withDirectives(_createElementVNode("span", null, [
                                  _createElementVNode("span", _hoisted_273, [
                                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen043.svg" })
                                  ]),
                                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("salesOrderOverview.generateOrder")), 1)
                                ], 512), [
                                  [_vShow, !_ctx.loading]
                                ])
                              ], 8, _hoisted_271))
                            : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["rules", "model"]),
    _createVNode(_component_add_product_item_modal, {
      form: _ctx.formData,
      onUpdateList: _ctx.updateProductItem
    }, null, 8, ["form", "onUpdateList"]),
    _createVNode(_component_add_sku_modal, {
      form: _ctx.formData,
      onUpdateList: _ctx.updateProductItem
    }, null, 8, ["form", "onUpdateList"]),
    _createVNode(_component_range_size_change, {
      ref: "rangeSizeChangeModalRef",
      onUpdateList: _ctx.rangeSizeChange
    }, null, 8, ["onUpdateList"]),
    _createVNode(_component_update_shipping_fee, {
      amount: _ctx.formData.base_shipping_amount,
      onUpdateList: _ctx.updateShippingFee
    }, null, 8, ["amount", "onUpdateList"])
  ], 64))
}